import { effects } from 'redux-saga'

import { timeout as timeoutAction } from '../../modules/authentication'
import timeout from '../../../util/timeout'

/**
 * Waits for the given interval and will timeout after there has been
 * no activity in the interval time.
 */
export default function* timeoutSaga(interval) {
  yield effects.call(timeout, interval)
  yield effects.put.resolve(timeoutAction())
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/authentication/timeout.js